const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Dsmax(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2947 2947",
    style: {
      enableBackground: "new 0 0 2947 2947"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#001717"
    },
    d: "M1376.2,815.5l-3.4-1.2v-313l3.5-3.1l1.2-1.9l1156.4,749.6L1376,815.8L1376.2,815.5z M1376.2,1676.5 l-0.1-0.4l1157.8-429.9l-1156.5,749.6l-1.1-1.7h-3.5v-316.4L1376.2,1676.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015051"
    },
    d: "M1909.4,0l624.5,1245.7L1377.5,496.2l-1.5-1l0.2-0.6L1905.6,3.5L1909.4,0z M2533.9,1246.2 L1909.4,2492l-3.5-3.4l-529.6-491.2l-0.2-0.6l1.3-1L2533.9,1246.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#016B6B"
    },
    d: "M1376,495.2l1.5,1l-1.2,1.9H529.4l-7.6-2.9L733.3,3l1.1,0.5h1171.3l-529.3,491.1L1376,495.2z  M1376.3,498.1l-3.5,3.1v-3.1H1376.3z M1376.3,1994.1l1.1,1.7l-1.3,1l0.2,0.6l529.6,491.2H734.4l-1.1,0.5l-211.5-492.3l7.1-2.7 H1369l3.7,3.5v-3.5H1376.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#015051"
    },
    d: "M1376,815.8l1157.8,429.9v0.5L1376,1676.2l0.1,0.4l-3.4,1.2V814.3l3.4,1.2L1376,815.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#016B6B"
    },
    d: "M1372.8,1994.1v3.5l-3.7-3.5H1372.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002122"
    },
    d: "M1372.8,1677.7v316.4h-3.7l-240.9-224.7L1372.8,1677.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#016B6B"
    },
    d: "M1372.8,1676.6v1.1l-244.7,91.7l-555.5-522.7v-1.5l555.5-522.7l244.7,91.7V1247V1676.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#002122"
    },
    d: "M1372.8,501.3v313l-244.7-91.7L1372.8,501.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#013535"
    },
    d: "M1372.8,498.1v3.1l-244.7,221.3L529.4,498.1H1372.8z M1369,1994.1H528.9l599.2-224.7L1369,1994.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M910.2,2574.4h96.9l31.6,121.5l10.3,48.1h1.7l10.3-48.1l29.8-121.5h96.9V2947h-79.1v-87.7 c0-11.1,0.5-25.2,1.5-42.1c1-17.1,2.1-34.6,3.1-52.7c1.1-18.1,2.5-35.7,4-52.5c1.6-16.8,2.9-30.7,4-41.8h-1.7l-31,110.7l-19.5,67.1 h-42.4l-19.5-67.1l-29.3-110.7h-2.3c1.1,11.1,2.5,25,4,41.8c1.6,16.8,2.9,34.3,4,52.5c1.1,18.1,2.2,35.8,3.1,52.7 c1,17.1,1.5,31.1,1.5,42.1v87.7h-78L910.2,2574.4z M1507.5,2867.9h-102.1l-18.4,79.1h-100.9l112.3-372.6h119.2l112.3,372.6h-104.4 L1507.5,2867.9z M1489.8,2791.6l-5.7-25.8c-4.2-18-8.6-37.5-13.2-58.4c-4.6-21-9.2-40.9-13.8-59.6h-2.3 c-4.2,19.1-8.5,39.1-12.9,59.9c-4.4,20.8-8.7,40.3-12.9,58.2l-5.7,25.8H1489.8L1489.8,2791.6z M1805.5,2755.6l-101.5-181.2h110.1 l29.7,60.7c4.2,8.8,8.6,18.3,13.2,28.4s9.6,21.3,14.9,33.5h2.3c4.2-12.2,8.3-23.5,12.6-33.5c4.2-10.2,8.2-19.6,12.1-28.4l26.4-60.7 h105.5l-101.5,185.8L2037,2947h-110.1l-34.3-66.5c-5.3-9.9-10.3-19.8-14.6-29.8s-9.1-20.7-14-32h-2.3c-4.2,11.5-8.5,22.1-12.9,32 c-4.4,9.9-8.8,19.8-13.4,29.8l-32,66.5h-105.5L1805.5,2755.6L1805.5,2755.6z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dsmax);
export default __webpack_public_path__ + "static/media/3dsmax.23b0fe16356bbceba3b9892b270bd2f0.svg";
export { ForwardRef as ReactComponent };